import { PaperPreset } from "./types";

export const PAPER_PRESETS: PaperPreset[] = [
  {
    id: "a4",
    kind: "sheet",
    sheetName: "A4",
    pageWidthMm: 210,
    pageHeightMm: 297,
    labelWidthMm: 63,
    labelHeightMm: 38,
  },
  {
    id: "letter",
    kind: "sheet",
    sheetName: "Letter",
    pageWidthMm: 216,
    pageHeightMm: 279,
    labelWidthMm: 64,
    labelHeightMm: 38,
  },
  {
    id: "roll-40x30",
    kind: "roll",
    labelWidthMm: 40,
    labelHeightMm: 30,
  },
  {
    id: "roll-50x30",
    kind: "roll",
    labelWidthMm: 50,
    labelHeightMm: 30,
  },
  {
    id: "roll-50x35",
    kind: "roll",
    labelWidthMm: 50,
    labelHeightMm: 35,
  },
  {
    id: "roll-100x50",
    kind: "roll",
    labelWidthMm: 100,
    labelHeightMm: 50,
  },
  {
    id: "roll-102x152",
    kind: "roll",
    labelWidthMm: 101.6,
    labelHeightMm: 152.4,
  },
];

export const DEFAULT_PAPER_PRESET_ID = PAPER_PRESETS[0].id;

export const CUSTOM_PAPER_ID = "custom";

export const getPaperPreset = (id: string): PaperPreset =>
  PAPER_PRESETS.find(preset => preset.id === id) ?? PAPER_PRESETS[0];

// Templates designed for a thermal roll size (e.g. 50×30) should print on
// that roll, not tiled on A4. Half a millimetre of slack covers sizes saved
// as 50.0 vs 50 or rounded from inches.
export const rollPresetForLabelSize = (
  widthMm: number,
  heightMm: number,
): PaperPreset | undefined =>
  PAPER_PRESETS.find(
    preset =>
      preset.kind === "roll" &&
      Math.abs(preset.labelWidthMm - widthMm) <= 0.5 &&
      Math.abs(preset.labelHeightMm - heightMm) <= 0.5,
  );
